import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  contact: null,
  contactList: [],
};

const route = "modules/workOrders/views/contactTab/modals/deleteContact/redux/slice";

export const workOrderDeleteContact = createAsyncThunk("manage/deleteContact/bulkDeleteEntityContact", async (payload, { rejectWithValue }) => {
  try {
    const response = await clientMutation(
      `mutation bulkDeleteEntityContact ($ids: [Int!]) {
        result: bulkDeleteEntityContact (ids: $ids)
      }`,
      payload,
      endpoints.GRAPHQL_GENERAL_V2
    );

    return { delete: response?.result }

  } catch (exc) {
    ExceptionManager(exc, route, "bulkDeleteEntityContact");
    return rejectWithValue(exc);
  }
}
);


const workOrdersDeleteContactRedux = createSlice({
  name: "workOrders/deleteContact",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalDeleteContact(state, action) {
      state.open = true;
      state.contact = action?.payload?.contact;
      state.contactList = action?.payload?.contactList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageDeleteManageWorkOrderType
    builder.addCase(workOrderDeleteContact.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrderDeleteContact.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(workOrderDeleteContact.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersDeleteContactRedux; 

// Extract and export each action creator by name
export const { reset, openModalDeleteContact } = actions;

// Export the reducer, either as a default or named export
export default reducer;